<template>
  <div class='outer-map-container' :style="{width: mapSize[0], height: mapSize[1]}">
    <search-tool></search-tool>
    <designatron></designatron>
    <!-- Test button for loading modal -->
    <!-- <b-button :pressed.sync="test_modal" v-b-tooltip.hover variant="dark" class="toolbar-button tool1" >+</b-button> -->


    <div id="map-holder">
      <div id="map">
      </div>
      <div v-if="profileShow" id="profile" :class="{'profile-holder': true, 'profile-holder-shown': profileShow}">
        <profile-viewer></profile-viewer>
      </div>
      <!--!!! DO NOT USE CLASS FOR SHOWING TEMPORAL SCALE, THERE IS ISSUE WITH FILTERING WIDGETS-->
      <div id="tmp_scale" v-if="temporalShow">
        <temporal-scale ></temporal-scale>
      </div>

    </div>
    <div id='unlocked-window-container'></div>
    <map-controls></map-controls>
    <map-mouse-pointer v-if="isToolEnabled('map_cursor_coords') && !profileShow"></map-mouse-pointer>
    <div v-show="$store.getters['project/showWidgetGrid']" class="gridstack-container ">
      <div :class="'grid-stack'">

      </div>
    </div>
    <div class='outer-legend-container' v-if="$store.getters['map/activatedLegends'].length">
      <div class='legend-title'>Map Legend</div>
      <div class='inner-legend-container'>
        <b-list-group v-for="l in $store.getters['map/activatedLegends']" v-bind:key="l.name">
          <div class='legend-item-title'>{{l.name}}</div>
          <img :src="l.src"></img>
        </b-list-group>
      </div>
    </div>
    <b-modal hide-header hide-footer v-model="showLoader"
             :rows="3"
             :max-rows="5">
      <div class='loading-container'>
        <img src="../assets/kegs-preloader.gif">
      </div>
      <div class="loading-text">
        Loading ...
      </div>
    </b-modal>
    <b-modal v-model="showAdmin" hide-footer size="lg">
      <admin-board v-if="showAdmin"></admin-board>
    </b-modal>
    <b-modal v-model="showReleaseNotes" no-close-on-backdrop no-close-on-esc
             :rows="3" :max-rows="5">

      <div slot="modal-header" class="w-100 release-header">
        <div class="release-notes-title">Release Notes</div>
        <!-- <b-button size="sm" variant="dark" type="dark" class="headerSmallButton"><icon name="window-close" scale=".7"></icon></b-button> -->
      </div>
      <div class="release-notes-container">
        <div v-if='newRelease' class="release-notes-warning">You may need to refresh your browser to see changes</div>
        <b-list-group v-if='releaseNotes.length' class="release-notes-list" v-for="(notes, gindex) in releaseNotes" :key="`group-note-${gindex}`">
          <b-list-group-item class="release-note" v-for="(note, index) in notes" :key="`note-${gindex}-${index}`">
            {{note}}
          </b-list-group-item>
        </b-list-group>
      </div>
      <div slot="modal-footer" class="w-100 release-footer">
        <span class="release-walkthrough" v-b-tooltip.hover title="Start Walkthrough" @click.prevent="showTour">
          <icon name="question-circle"></icon>
        </span>
        <b-btn v-if='newRelease' size="sm" class="float-right" variant="primary" @click="newRelease = false">
          Continue to KEGS
        </b-btn>
        <b-btn v-if='releaseNav' size="sm" class="float-right" variant="primary" @click="releaseNav = false">
          Close
        </b-btn>
      </div>
    </b-modal>

  </div>
</template>

<script>

  import 'vue-awesome/icons/plus'
  import 'vue-awesome/icons/minus'
  import 'vue-awesome/icons/expand'
  import 'vue-awesome/icons/search'
  import 'vue-awesome/icons/arrows-alt'
  import 'vue-awesome/icons/check-square'
  import 'vue-awesome/icons/angle-up'
  import 'vue-awesome/icons/window-maximize'
  import 'vue-awesome/icons/window-close'
  import 'vue-awesome/icons/list-alt'
  import 'vue-awesome/icons/square'
  import 'vue-awesome/icons/fast-backward'
  import 'vue-awesome/icons/fast-forward'
  import 'vue-awesome/icons/backward'
  import 'vue-awesome/icons/forward'
  import 'vue-awesome/icons/play'
  import 'vue-awesome/icons/pause'
  import 'vue-awesome/icons/stop'

  import Designatron from './Designatron.vue'
  import SearchTool from './map/SearchTool.vue'
  import AdminBoard from './user/AdminBoard.vue'

  import Vue from 'vue'
  import Map from 'ol/Map'
  import * as control from 'ol/control'
  import View from 'ol/View'
  import ScaleLine from 'ol/control/ScaleLine'
  import ContextMenu from 'ol-contextmenu'
  import MapPlugin from '../plugin/map'
  import MapControls from './map/MapControls'
  import ProfileViewer from './map/ProfileViewer'
  import TemporalScale from './map/TemporalScale'
  import DroneImageryMixin from '../mixins/DroneImageryMixin'
  import MapMousePointer from './map/MapMousePointer'

  import Select from 'ol/interaction/Select'
  import IconStyle from 'ol/style/Icon'
  import Fill from 'ol/style/Fill'
  import Style from 'ol/style/Style'
  import Stroke from 'ol/style/Stroke'
  import Feature from 'ol/Feature'
  import Point from 'ol/geom/Point'
  import VectorLayer from 'ol/layer/Vector'
  import VectorSource from 'ol/source/Vector'
  import { transformGeometry } from '../util/map'

  var center_icon = '//cdn.rawgit.com/jonataswalker/ol3-contextmenu/master/examples/img/center.png';

  export default {
    mixins: [DroneImageryMixin],
    components: {
      MapMousePointer,
      ProfileViewer,
      TemporalScale,
      MapControls,
      Designatron,
      SearchTool,
      AdminBoard
    },
    data () {
      return {
        releaseNotes: [],
        newRelease: false,
        contextmenu_items: [],
        contextmenu_feature: null,
        context_show_centreline: false,
        context_draw_wellpad: false,
        context_coords: [],
        elevation: null
      }
    },
    props: {
      workpack_id: {
        default: null
      }
    },
    watch: {
      camera3dPotistion (val) {
        this.updateCameraPoint()
      },
      angle3d (val) {
        this.updateCameraPoint()
      },
      releaseNav (val) {
        if (this.releaseNotes.length <= 0) {
          this.loadReleaseNotes()
        }
      },
      profileShow () {
        setTimeout(() => {
          this.$mapService.map.updateSize()
        }, 400)
      },
      layersSorted (val) {
        let me = this
        if (val) {
          setTimeout(function(){
            me.$mapService.walkTree(me.$store.getters['map/layersTree'], node => {
              if (node && me.$store.getters['map/renderedLabelsMap'][node['name']]) {
                let layer = me.$mapService._layerExists(node)
                if (layer) {
                  me.$mapService.setLayerLabel(node ,me.$store.getters['map/renderedLabelsMap'][node['name']])
                }
              }
            })
          }, 1000)
        }
      }
    },
    computed: {
      camera3dPotistion () {
        return this.$store.getters['map/camera3dPotistion']
      },
      angle3d () {
        return this.$store.getters['map/angle3d']
      },
      countGridCols () {
        let c = 24

        switch (true) {
          case screen.width <= 800:
            c = 8
            break
          case screen.width > 800 && screen.width <= 1024:
            c = 10
            break
          case screen.width > 1024 && screen.width <= 1280:
            c = 12
            break
          case screen.width > 1280 && screen.width <= 1700:
            c = 14
            break
          case screen.width > 1700 && screen.width <= 1920:
            c = 20
            break
        }
        return c
      },
      profileShow: {
        get () {
          return this.$store.getters['map/profileShow']
        },
        set (val) {
          this.$store.commit('map/profileShow', val)
        },
      },
      releaseNav: {
        get () {
          return this.$store.getters['map/showReleaseNotes']
        },
        set (val) {
          this.$store.commit('map/showReleaseNotes', val)
        },
      },
      temporalShow: {
        get () {
          return this.$store.getters['map/temporalShow']
        },
        set (val) {
          this.$store.commit('map/temporalShow', val)
        },
      },
      mapSize () {
        let ms = this.$store.getters['map/mapSize']
        if (!ms) {
          return ['100%', '100%']
        }
        return ms.map(s => s + 'px')
      },
      showReleaseNotes: {
        get () {
          return false
          // return ((this.$store.getters['map/layersLoaded'] != 0) && this.newRelease) || this.releaseNav
        },
        set (val) {
          return val
        }
      },
      showLoader: {
        get () {
          return this.$store.getters['map/layersLoaded'] === 0 && this.$store.getters['project/currentProject'] !== null
        },
        set (val) {
          return val
        }
      },
      showAdmin: {
        get () {
          return this.$store.getters['user/showAdmin']
        },
        set (val) {
          this.$store.commit('user/showAdmin', val)
        }
      },
      layersSorted () {
        return this.$store.getters['map/layersSorted']
      }
    },
    mounted () {
      if (!this.workpack_id && this.$store.getters['project/currentProject'] && this.$store.getters['project/currentProject'].workpack) {
        this.$router.push(`/${this.$store.getters['project/currentProject'].workpack.id}`)
      }
      let me = this
      $(function () {
        window.widgetsGridStack = $('.grid-stack').gridstack({
          float: true,
          handle: '.windowHeader',
          width: me.countGridCols,
          height: $('.gridstack-container').height() / 80
        })

        console.log(`grid width: ${me.countGridCols}`)
        window.widgetsGridStack.on('gsresizestop', function (event, elem) {
          me.$store.commit('map/widgetResizeMap', [$(elem).attr('data-gs-id'), new Date().getTime()])
          localStorage.setItem($(elem).attr('data-gs-id'), [$(elem).attr('data-gs-width'), $(elem).attr('data-gs-height')])
        })
      })

      this.iniProjectsAndMap()
      this.initPolyfills()
      this.getWikiProject()

    },
    methods: {
      context_map3DZoom () {
        this.$store.commit('map/context_coords', this.context_coords)
        this.$store.getters['cmp/all']['pc']['enabled'] = true
      },
      context_calc_elevation () {
        this.$http.get('/api/layers/get-elevation', {
          params: {
            point: `POINT(${this.context_coords.join(' ')})`
          }
        })
          .then(res => {
            this.$store.commit('map/context_elevation', res.body.elevation)
            this.$notify({
              title: 'SUCCESS',
              text: 'Elevation calculated',
              type: 'success'
            })
          }, res => {
            console.error(res)
            this.$notify({
              title: 'ERROR',
              text: 'Could not get elevation',
              type: 'error'
            })
          })
      },
      context_open_profile () {
        this.$store.commit('map/context_centreline', this.contextmenu_feature)
        this.$store.commit('map/profileShow', true)
      },
      context_trace_route (fid) {
        this.$http.get(`/api/layers/trace-route`, {
          params: {
            feature_id: this.contextmenu_feature
          }
        }).then(res => {

            let ids = res.body[0].centreline_sub_connectivity

            if (!this.trace_route_centreline_layer) {
              this.trace_route_centreline_layer = this.$mapService.map.getLayers().getArray().filter(layer => {
                return layer.get('kegs_name') === 'v4:centreline' && (layer instanceof VectorLayer)
              })[0]
              this.trace_route_pad_layer = this.$mapService.map.getLayers().getArray().filter(layer => {
                return layer.get('kegs_name') === 'v4:_wellpad' && (layer instanceof VectorLayer)
              })[0]
            }

            let style = new Style({
              stroke: new Stroke({
                color: '#98FB98',
                width: 6
              }),
              fill: new Fill({
                color: 'rgba(0, 0, 255, 0.1)'
              })
            })

            if (this.selectInteraction && this.selectInteraction.getFeatures()) {
              this.selectInteraction.getFeatures().clear()
            }

            this.$mapService.removeInteraction(this.selectInteraction)

            this.selectInteraction = new Select({
              hitTolerance: 8,
              layers: [this.trace_route_centreline_layer],
              style: style
            })

            this.$mapService.addInteraction(this.selectInteraction)
            ids.forEach(id => {
              if (id.charAt(0) !== 'c') {
                return
              }
              let layer = this.trace_route_centreline_layer
              let fid = id.slice(1)
              layer.getSource().getFeatures().forEach(f => {
                if (f && f.get('id') && f.get('id') == fid) {

                  this.selectInteraction.getFeatures().push(f)
                  this.selectInteraction.dispatchEvent({
                     type: 'select',
                     selected: [f],
                     deselected: []
                  });
                }
              })
            })
            this.selectInteraction.on('select', this.onClick, this)
            this.selectInteraction.on('deselect', this.onClick, this)

          }, e => {
            this.$notify({
              title: 'ERROR',
              text: 'Could not trace route',
              type: 'error'
            })
          })
      },
      context_draw_pad (fid) {
        this.$http.get(`/api/layers/redraw-pad`, {
          params: {
            feature_id: this.contextmenu_feature
          }
        }).then(res => {
            let layer = null
            this.$mapService.walkTree(this.$store.getters['map/layersTree'], node => {
              if (node['name'] == 'v4:_wellpad') {
                layer = node
              }
            })
            this.$mapService.forceCreateLayer(layer)
          }, e => {
            this.$notify({
              title: 'ERROR',
              text: 'Could not redraw wellpad',
              type: 'error'
            })
          })
      },
      onClick () {
        this.selectInteraction.getFeatures().clear()
        this.$mapService.removeInteraction(this.selectInteraction)
      },
      showTour () {
        // this.$store.commit('map/showReleaseNotes', false)
        // this.$store.commit('map/showTour', true)
      },
      // CLEAN tool enabled
      isToolEnabled(toolName) {
        let currentProject = this.$store.getters['project/currentProject']
        if (!currentProject || !currentProject.workpack) {
          return false
        }
        let enabled = true
        if (currentProject.workpack && currentProject.workpack['tool_map']) {
          enabled = currentProject.workpack['tool_map']['*'] || currentProject.workpack['tool_map'][toolName]
        }
        return enabled
      },
      setCurrentProject (projectsTree, workpackId) {
        let walk = (node) => {
          if (node['children']) {
            node['children'].forEach(walk)
          }

          if (node.workpack && node.workpack.id === workpackId) {
            this.$store.commit('project/currentProject', node)
          }
        }
        projectsTree.forEach(walk)
      },
      getWikiProject () {
        let me = this
        this.$http.get(`/api/layers/get-wiki-projectid`)
          .then(res => {
            if (res && res.body && res.body.project_id) {
              me.$store.commit('project/wikiProjectId', res.body.project_id)
            }
          }, e => {
            this.$notify({
              title: 'ERROR',
              text: 'Could not load Redmine wiki project id',
              type: 'error'
            })
          })
      },
      getWorkpackId () {
        return this.workpack_id || (this.$store.getters['project/currentProject'] ? this.$store.getters['project/currentProject'].workpack.id : null)
      },
      iniProjectsAndMap () {
        Vue.use(MapPlugin, {map: this.initMap()})

        let workpackId = this.getWorkpackId()
        if (workpackId) {
          workpackId = parseInt(workpackId)
        }
        this.$store.commit('user/loading', true)
        this.$store.commit('map/initialised', true)

        this.$apiProjects.loadProjects(projectsTree => {
          this.$store.commit('project/projects', projectsTree)
          workpackId && this.setCurrentProject(projectsTree, workpackId)
          this.$apiProjects.pollTaskStats()
        }, err => {
          this.$notify({
            title: 'ERROR',
            text: 'Could not load project list',
            type: 'error'
          })
        })

        if (!workpackId) {
          //show projects popup
          return
        }

        this.loadWorkpackLayers(workpackId)

      },
      initPolyfills () {
        // TODO move this to somewhere more appropriate
        if (!String.prototype.repeat) {
          String.prototype.repeat = function(count) {
            'use strict';
            if (this == null) {
              throw new TypeError('can\'t convert ' + this + ' to object')
            }
            var str = '' + this
            count = +count
            if (count != count) {
              count = 0
            }
            if (count < 0) {
              throw new RangeError('repeat count must be non-negative')
            }
            if (count == Infinity) {
              throw new RangeError('repeat count must be less than infinity')
            }
            count = Math.floor(count)
            if (str.length == 0 || count == 0) {
              return '';
            }
            // Ensuring count is a 31-bit integer allows us to heavily optimize the
            // main part. But anyway, most current (August 2014) browsers can't handle
            // strings 1 << 28 chars or longer, so:
            if (str.length * count >= 1 << 28) {
              throw new RangeError('repeat count must not overflow maximum string size')
            }
            var maxCount = str.length * count
            count = Math.floor(Math.log(count) / Math.log(2))
            while (count) {
               str += str;
               count--;
            }
            str += str.substring(0, maxCount - str.length)
            return str
          }
        }
      },
      initMap () {
        let center = null
        let resolution = null
        let mapScope = this.$store.getters['map/mapScope']
        if (mapScope && mapScope[this.workpack_id]) {
          center = mapScope[this.workpack_id]['center']
          resolution = mapScope[this.workpack_id]['resolution']
        }

        let scaleLineControl = new ScaleLine()

        let map = new Map({
          target: 'map',
          layers: [],
          view: new View({
            center: center || [16824158.9688553, -3185807.29806573],
            zoom: resolution || 12,
            maxZoom: 21,
            projection: 'EPSG:3857'
          }),
          controls: control.defaults({
            attribution: false,
            zoom: false
          }).extend([
            scaleLineControl
          ])
        })

        // TODO: clean context menu
        this.contextmenu_items.push({
          id: 3,
          text: 'Calculate elevation here',
          icon: center_icon,
          callback: this.context_calc_elevation
        })
        if (this.isToolEnabled('potree')) {
          let potreeContext = {
            id: 1,
            text: 'Zoom to in 3D Map',
            icon: center_icon,
            callback: this.context_map3DZoom
          }
          this.contextmenu_items.push(potreeContext)
        }

        var contextmenu = new ContextMenu({
          width: 200,
          defaultItems: true,
          items: this.contextmenu_items
        });
        let me = this

        contextmenu.on('open', function (evt) {
          me.context_coords = evt['coordinate']
        })

        contextmenu.on('beforeopen', function (evt) {
          let type = null
          var feature = map.forEachFeatureAtPixel(evt.pixel, function (ft, l) {
            if (ft.get('centreline_type')) {
              type = 'centreline'
              return ft;
            }
            if (ft.get('wellpadtype')) {
              type = 'pad'
              return ft;
            }
          }, {hitTolerance: 10});


          if (feature && !me.profileShow) {
            if (type == 'centreline') {
              if (!me.context_show_centreline) {
                contextmenu.extend([
                  {
                    id: 2,
                    text: 'Open centerline in profile',
                    icon: center_icon,
                    callback: me.context_open_profile
                  },
                  {
                    id: 3,
                    text: 'Trace Route',
                    icon: center_icon,
                    callback: me.context_trace_route
                  }
                ])
              }
              me.contextmenu_feature = feature.get('id')
              me.context_show_centreline = true
            }
            if (type == 'pad') {
              if (!me.context_draw_wellpad) {
                contextmenu.extend([
                  {
                    id: 4,
                    text: 'Redraw wellpad',
                    icon: center_icon,
                    callback: me.context_draw_pad
                  }
                ])
              }
              me.contextmenu_feature = feature.get('id')
              me.context_draw_wellpad = true
            }
          }
          else {
            contextmenu.clear()
            contextmenu.extend(contextmenu.getDefaultItems())
            contextmenu.extend(me.contextmenu_items)
            me.context_show_centreline = false
            me.context_draw_wellpad = false
          }
        })

        map.addControl(contextmenu);

        map.on('click', function() {
          contextmenu.close()
        }, this)

        map.getView().on('change:center', () => {
          // console.log(map.getView().getCenter())
          this.$store.commit('map/center', [this.workpack_id, map.getView().getCenter()])
        })

        map.getView().on('change:resolution', () => {
          this.$store.commit('map/resolution', [this.workpack_id, map.getView().getZoom()])
        })

        this.init3dServicingLayers(map)

        return map
      },
      updateCameraPoint() {
        // console.log(this.angle3d)
        // console.log(this.camera3dPotistion)
        let p = new Point(this.camera3dPotistion.split(',').map(c => parseFloat(c)))
        p = transformGeometry(p, 'EPSG:28356', 'EPSG:3857')
        this.cameraPoint.setGeometry(p)
        this.cameraStyle.setRotation((this.angle3d * Math.PI)/180)

      },
      init3dServicingLayers(map) {

        this.cameraPoint = new Feature(new Point([0, 0]))
        this.cameraStyle= new IconStyle({
          src: '/static/img/icons/binoculars-pointing-up.png',
          rotateWithView: true,
          rotation: 0
        })

        this.servicing3dLayerCamera = new VectorLayer({
          source: new VectorSource({
            features: [
              this.cameraPoint
            ]
          }),
          style: (f) => {
            return [new Style({
              image: this.cameraStyle
            })]
          }
        })

        this.servicing3dLayerCamera.set('kegs_id', 'camera_custom_v5')

        map.addLayer(this.servicing3dLayerCamera);


        //init drawing generic tool
        let source = new VectorSource()
        let layer = new VectorLayer({
          source: source,
          style: new Style({
            fill: new Fill({
              color: 'rgba(204, 0, 0, 0.3)'
            }),
            stroke: new Stroke({
              color: 'rgba(204, 0, 0, 0.8)',
              width: 2
            })
          })
        })

        layer.set('kegs_id', 'drawing_custom_v5')
        map.addLayer(layer);


      },
      loadWorkpackLayers (workpackId) {
        // workaround remove qa layer from local storage for previous users
        try {
          if (localStorage.getItem('layer_tool_' + this.$store.getters['project/currentProject'].workpack.id + '_v4:_buildtestresults') == 'true') {
            localStorage.removeItem('layer_tool_' + this.$store.getters['project/currentProject'].workpack.id + '_v4:_buildtestresults');
          }
        } catch (e) {
          console.log("ERROR: "+e)
        }

        this.$apiLayers.loadLayers(workpackId, tree => {
          this.$store.commit('map/temporalLayers', [])
          this.$store.commit('map/layersTree', tree)
          this.$store.commit('map/layersLoaded', new Date().getTime())

          if (localStorage.getItem('newRelease') === 'true') {
            this.loadReleaseNotes(true)
          }
          if (this.injectStyle) {
            this.injectStyle()
          }
        }, res => {
          console.error(res)
        })
      },
      loadReleaseNotes (firstLoad) {
        let me = this

        this.$http.get('/api/layers/release-redmine-issue')
          .then(res => {
            callback(res.body.issue_id)
          }, r => {
            this.$notify({
              title: 'ERROR',
              text: 'Could not get release redmine issue id',
              type: 'error'
            })
          })

        let callback = function (issue_id) {
          me.$http.get(`/api/redmine/issues/${issue_id}.json?include=journals`)
            .then(res => {
              if (res && res.body && res.body.issue) {
                let journals = res.body.issue.journals.reverse()
                let notes = []
                journals.forEach(j =>  {
                  if (j.notes.includes('Release')) {
                    let n = j.notes.split('-')
                    n = n.filter(p => p.length)
                    notes.push(n)
                  }
                })
                if (notes.length > 0) {
                  me.releaseNotes = notes
                  if (firstLoad) {
                    me.newRelease = true
                    localStorage.setItem('newRelease', false)
                  }
                }
              }
            }, r => {
              me.$notify({
                title: 'ERROR',
                text: 'Could not get release redmine issue',
                type: 'error'
              })
            })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Map.vue